import type { ReactNode } from 'react'

import { Card } from './Card'
import styles from './KpiCard.module.css'

export interface KpiCardProps {
  icon: ReactNode
  label: ReactNode
  value: ReactNode
  delta?: ReactNode
  deltaDirection?: 'up' | 'down'
}

export function KpiCard({ icon, label, value, delta, deltaDirection = 'up' }: KpiCardProps) {
  return (
    <Card className={styles.card}>
      <span className={styles.icon}>{icon}</span>
      <div>
        <p className={styles.label}>{label}</p>
        <p className={styles.value}>{value}</p>
        {delta ? <p className={styles.delta}><span className={styles[deltaDirection]}>{delta}</span></p> : null}
      </div>
    </Card>
  )
}
